export const bookConstant = {
    SEARCH_FAIL: 'SEARCH_BOOK_FAIL',
    SEARCH_SUCCESS: 'SEARCH_BOOK_SUCCESS',
    SEARCH_REQUEST: 'SEARCH_BOOK_REQUEST',
    SEARCH_AUTHOR_FAIL: 'SEARCH_AUTHOR_FAIL',
    SEARCH_AUTHOR_SUCCESS: 'SEARCH_AUTHOR_SUCCESS',
    SEARCH_AUTHOR_REQUEST: 'SEARCH_AUTHOR_REQUEST',
    ADD_FAIL: 'ADD_BOOK_FAIL',
    ADD_SUCCESS: 'ADD_BOOK_SUCCESS',
    ADD_REQUEST: 'ADD_BOOK_REQUEST',
    PAGINATE_FAIL: 'PAGINATE_BOOK_FAIL',
    PAGINATE_SUCCESS: 'PAGINATE_BOOK_SUCCESS',
    PAGINATE_REQUEST: 'PAGINATE_BOOK_REQUEST',
    GET_FAIL: 'GET_BOOK_FAIL',
    GET_SUCCESS: 'GET_BOOK_SUCCESS',
    GET_REQUEST: 'GET_BOOK_REQUEST',
    SHOULD_FAIL: 'SHOULD_BOOK_FAIL',
    SHOULD_SUCCESS: 'SHOULD_BOOK_SUCCESS',
    SHOULD_REQUEST: 'SHOULD_BOOK_REQUEST',
    RESET: 'RESET_BOOK',
    ADD_LIST_FAIL: 'ADD_READ_LIST_BOOK_FAIL',
    ADD_LIST_SUCCESS: 'ADD_READ_LIST_SUCCESS',
    ADD_LIST_REQUEST: 'ADD_READ_LIST_REQUEST',
};

export default bookConstant;